import SidepanelDefaultRow from '../side-panel/side-panel-default-row';
import IconCopy from '../icons/copy-two';
import { TransactionAccountRowReadTypes } from './types';

import styles from './transaction.module.css';

export default function TransactionAccountRow({
  title,
  name,
  number,
  onCopy,
  copyIsSuccess,
}: TransactionAccountRowReadTypes): React.JSX.Element {
  return (
    <SidepanelDefaultRow
      title={title}
      valueClassName={onCopy ? styles.readCopyButtonWrapper : ''}
    >
      <div className={styles.transactionBlockAccount}>
        <div className={styles.transactionBlockAccountName}>{name}</div>
        <div className={styles.transactionBlockAccountNumber}>{number}</div>
      </div>
      {onCopy && (
        <button
          type="button"
          className={`${styles.readCopyButton} ${
            copyIsSuccess ? styles.success : ''
          }`}
          onClick={() => onCopy(`${name} (${number})`)}
          aria-label="Copy"
        >
          <IconCopy />
        </button>
      )}
    </SidepanelDefaultRow>
  );
}
